import { getCompanySelected } from '../../utilities/controlStorage'

export const companySelected = getCompanySelected()
